export const PLAN = {
  ERROR_CODE: {
    CI_NOT_ELIGIBLE: 'BEFORE_CI_12_DATE',
    FE_CHECK: 'MANUAL_CHECK_REQUIRED'
  },
  MS_OFFERING_NAME: 'MOBILESHARE'
};

export enum PLAN_GROUPS {
  MOBILE_SHARE = 'MOBILE SHARE'
}
